
import { AfterViewInit, Component } from '@angular/core';
import { DelegateDto } from '@models/users/delegate.dto';
import { Roles } from '@models/users/role.const';
import { SubscriberDto } from '@models/users/subscriber.dto';
import { SubscriberService } from '@services/subscriber.service';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-delegates',
  templateUrl: './delegates.component.html',
  styleUrls: ['./delegates.component.scss'],
})
export class DelegatesComponent implements AfterViewInit {
  public subscribers: SubscriberDto[] = [];

  public delegates: DelegateDto[] = [];

  public filteredSubscribers: SubscriberDto[] = [];

  public editingFather: DelegateDto | null = null;

  public search: string = '';

  public currentlyEditing: DelegateDto | null = null;

  public clonedDelegateDtos: {
    [s: number]: DelegateDto;
  } = {};

  public creating: DelegateDto | undefined;

  public get roles() {
    return Roles;
  }

  public get fatherMap(): {
    [key: number]: any;
  } {
    const map: {
      [key: number]: any;
    } = {};

    this.delegates.forEach((delegate) => {
      if (delegate.delegateId !== undefined) {
        map[delegate.delegateId] = delegate.user;
      }
    });

    return map;
  }

  constructor(
    public dialogService: DialogService,
    private subscriberService: SubscriberService,
  ) {}

  ngAfterViewInit(): void {
    this.loadDelegates();
  }

  public loadDelegates(): void {
    this.subscriberService.getDelegates().subscribe((res) => {
      this.delegates = res;
    });
  }

  public possibleFathers(delegateId: number): number[] {
    const arr = this.delegates
      .filter((delegate) => delegate.delegateId !== delegateId)
      .map((delegate) => delegate.delegateId!);

    arr.push(-1);

    return arr;
  }

  public getFatherName(
    upperDelegateId: number | null | undefined,
  ): string {
    if (
      upperDelegateId === null ||
      upperDelegateId === undefined ||
      upperDelegateId === -1
    ) {
      return 'Claudio Cecchi';
    }

    const father = this.fatherMap[upperDelegateId];

    if (!father) {
      return 'Responsabile non disponibile';
    }

    return `${father.name} ${father.lastName}`;
  }

  public onRowEditInit(delegate: DelegateDto): void {
    this.clonedDelegateDtos[delegate.delegateId as number] = {
      ...delegate,
    };
  }

  public createNewDelegate(): void {
    this.subscriberService.getSubscribers().subscribe((result) => {
      const alreadyIn: number[] = this.delegates.map((delegate) =>
        delegate.user !== undefined
          ? delegate.user.subscriberId!
          : -1,
      );

      this.subscribers = result.filter(
        (subscriber) =>
          !alreadyIn.includes(subscriber.subscriberId!),
      );

      this.filteredSubscribers = [...this.subscribers];

      this.creating = {
        label: '',
        roleDescription: '',
        upperDelegateId: null,
      };
    });
  }

  public onCreateDialogVisibleChange(visible: boolean): void {
    if (!visible) {
      this.creating = undefined;
      this.filteredSubscribers = [];
    }
  }

  public confirmCreate(): void {
    if (
      this.creating !== undefined &&
      this.creating.user !== undefined
    ) {
      this.subscriberService
        .createDelegate([this.creating])
        .subscribe(() => {
          this.creating = undefined;
          this.filteredSubscribers = [];
          this.loadDelegates();
        });
    }
  }

  public onRowEditSave(delegate: DelegateDto): void {
    this.subscriberService
      .modifyDelegate([delegate])
      .subscribe(() => {
        delete this.clonedDelegateDtos[
          delegate.delegateId as number
        ];

        this.loadDelegates();
      });
  }

  public removeDelegate(delegate: DelegateDto): void {
    this.subscriberService
      .removeDelegate([delegate])
      .subscribe(() => {
        this.loadDelegates();
      });
  }

  public onRowEditCancel(
    delegate: DelegateDto,
    index: number,
  ): void {
    const original = this.clonedDelegateDtos[
      delegate.delegateId as number
    ];

    if (original) {
      this.delegates[index] = original;
    }

    delete this.clonedDelegateDtos[
      delegate.delegateId as number
    ];
  }

  public changedFather(
    delegate: DelegateDto,
    event: any,
  ): void {
    delegate.upperDelegateId =
      event.value !== -1 ? event.value : null;
  }

  public filterSubscriber(
    event: AutoCompleteCompleteEvent,
  ): void {
    const query = event.query.toLowerCase().trim();

    this.filteredSubscribers = this.subscribers.filter(
      (subscriber) => {
        const fullName =
          `${subscriber.name} ${subscriber.lastName}`.toLowerCase();

        return fullName.includes(query);
      },
    );
  }
}
